import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  date: {
    defaultMessage: "Created",
    id: "MFV2lK",
    description: "payment recovery column title",
  },
  lastActivity: {
    defaultMessage: "Last activity",
    id: "sj8Ur5",
    description: "payment recovery column title",
  },
  customer: {
    defaultMessage: "Customer",
    id: "EHjFal",
    description: "payment recovery column title",
  },
  gateway: {
    defaultMessage: "Gateway",
    id: "s6jVgw",
    description: "payment recovery column title",
  },
  status: {
    defaultMessage: "Status",
    id: "f6ZKtb",
    description: "payment recovery column title",
  },
  held: {
    defaultMessage: "Money held",
    id: "59lKJb",
    description: "payment recovery column title",
  },
  items: {
    defaultMessage: "Items",
    id: "C4lE6b",
    description: "payment recovery column title",
  },
  lastEvent: {
    defaultMessage: "Last event",
    id: "m2lfRD",
    description: "payment recovery column title",
  },
  channel: {
    defaultMessage: "Channel",
    id: "0P4UpP",
    description: "payment recovery column title",
  },
});

export const messages = defineMessages({
  emptyTextSearch: {
    defaultMessage: "No checkouts match this search",
    id: "dkkwWl",
    description: "payment recovery empty datagrid with an active search",
  },
  emptyText: {
    defaultMessage: "No stranded payments — every checkout that took money became an order",
    id: "XJyjvJ",
    description: "payment recovery empty datagrid",
  },
  captured: {
    defaultMessage: "Captured",
    id: "M5VwgX",
    description: "payment recovery money status",
  },
  authorized: {
    defaultMessage: "Authorized",
    id: "4yQXvS",
    description: "payment recovery money status",
  },
  needsReview: {
    defaultMessage: "Needs review",
    id: "tZ1E2e",
    description: "payment recovery money status",
  },
});
